export enum InventoryControlFlgEnum {
  YES = '0',
  NO = '1',
}

export const InventoryControlFlg = [
  { label: '在庫管理する', value: InventoryControlFlgEnum.YES },
  { label: '在庫管理しない', value: InventoryControlFlgEnum.NO },
];
